import React from 'react';
import LocatorSearchContainer from "../../containers/postshop-locator/LocatorSearchContainer";
import ResultsListContainer from "../../containers/postshop-locator/ResultsListContainer";
import "./PostshopLocator.scss";
import QuickSearchContainer from "../../containers/postshop-locator/QuickSearchContainer";
import {Button, Menu, MenuItem} from "@material-ui/core";
import {ApplicationState} from "../../redux/AppStore";
import {Dispatch} from "redux";
import {locatorFilterActions} from "../../redux/actions/postshop-locator/locatorFilterActions";
import {connect} from "react-redux";
import filterIcon from "./filter-o.svg";
import {PostshopServiceType} from "../../services/postshopServices";

const services:any[] = (Object.keys(PostshopServiceType) as Array<keyof typeof PostshopServiceType>).map((key) => ({id: key, label: PostshopServiceType[key]}))

interface IPostshopLocatorProps {
  geolocationSearch: Function;
  setLocationFilter: Function;
  selectedFilter: string
}

interface IPostShopLocatorState {
  anchorEl: any
}

const mapStateToProps = (state: ApplicationState) => ({selectedFilter: state.postshopLocator.selectedFilter});

/**
 * Map all relevant functions to properties with dispatch events
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    setLocationFilter: (selectedFilter: string) => dispatch(locatorFilterActions.setFilterRequested(selectedFilter)),
});



class PostshopLocator extends React.Component<IPostshopLocatorProps, IPostShopLocatorState> {
  constructor(props: IPostshopLocatorProps) {
    super(props);
    this.state = {
      anchorEl: null
    }
  }


  render() {

    const getServiceLabel = (serviceId: any) => {
      let foundItem = services.find((item) => item.id === serviceId);
      return foundItem ? ": " + foundItem.label : "";
    };

    const openFilterMenu = (event: any) => {
      this.setState({
        anchorEl: event.currentTarget,
      })
    };
    const selectFilter = (serviceId: any) => {
      this.setState({
        anchorEl: null
      }, () => this.props.setLocationFilter(serviceId))
    };

    const handleClose = () => {
      this.setState({
        anchorEl: null
      })
    };
    return (
      <div className="postshop-locator-container">
        <LocatorSearchContainer/>
          <div className="filter-container">
            <Button style={{
              borderRadius: 20,
              textTransform: "none",
              fontSize: 16,
              fontWeight: 500,
              color: "#343434",
            }} className="filter-label" aria-controls="filter-menu" onClick={openFilterMenu}>
              Filter by
              <span style={{fontWeight: "normal"}}>{getServiceLabel(this.props.selectedFilter)}</span>
              <img className="filter-icon" alt="Filter Icon" src={filterIcon}/>
            </Button>
            <Menu
              id="filter-menu"
              className="filter-menu"
              anchorEl={this.state.anchorEl}
              keepMounted
              open={Boolean(this.state.anchorEl)}
              onClose={handleClose}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem key="filter-menu-none" onClick={() => {selectFilter("")}} value="">
                  <em>All</em>
              </MenuItem>
              {services.map((service) =>
                <MenuItem key={`filter-menu-${service.id}`} onClick={() => {selectFilter(service.id)}} value={service.id}>
                  {service.label}
                </MenuItem>)}
            </Menu>
          </div>
        <ResultsListContainer/>
        <QuickSearchContainer/>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PostshopLocator);


// WEBPACK FOOTER //
// ./src/components/PostshopLocator/PostshopLocator.tsx